const markerIconSvg = () => `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="30" height="30">
        <style type="text/css">
            .st0{fill:#FFFFFF;}
            .st1{fill:#8A2BE2;}
            .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#8A2BE2;}
        </style>
        <g>
            <path class="st0" d="M256,506c-66.8,0-129.6-26-176.8-73.2C32,385.6,6,322.8,6,256S32,126.4,79.2,79.2C126.4,32,189.2,6,256,6
                s129.6,26,176.8,73.2C480,126.4,506,189.2,506,256s-26,129.6-73.2,176.8S322.8,506,256,506z"/>
            <path class="st1" d="M256,12c32.9,0,64.9,6.4,95,19.2c29.1,12.3,55.1,29.9,77.6,52.3c22.4,22.4,40,48.5,52.3,77.6
                c12.7,30.1,19.2,62,19.2,95s-6.4,64.9-19.2,95c-12.3,29.1-29.9,55.1-52.3,77.6c-22.4,22.4-48.5,40-77.6,52.3
                c-30.1,12.7-62,19.2-95,19.2s-64.9-6.4-95-19.2c-29.1-12.3-55.1-29.9-77.6-52.3c-22.4-22.4-40-48.5-52.3-77.6
                c-12.7-30.1-19.2-62-19.2-95s6.4-64.9,19.2-95c12.3-29.1,29.9-55.1,52.3-77.6c22.4-22.4,48.5-40,77.6-52.3
                C191.1,18.4,223.1,12,256,12 M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0L256,0z"/>
        </g>
        <g>
            <path class="st2" d="M121.5,214.8v148.5h70.7v-76c0-9.7,4.4-18.6,10.6-24.8s15-9.7,24.8-9.7H256v41.5h-21.3v76
                c0,9.7-4.4,18.6-10.6,24.8c-6.2,6.2-15,9.7-24.8,9.7h-84.9c-4.4,0-8.8-0.9-13.3-2.7c-4.4-0.9-8.8-3.5-12.4-6.2
                c-3.5-3.5-6.2-7.1-7.9-11.5c-1.8-4.4-2.7-8.8-2.7-13.3V212.1c0-5.3,0.9-9.7,2.7-14.1c2.6-4.4,5.3-8,8.8-11.5L231.1,61
                c6.2-5.3,15-8.8,23.9-8.8c0.3,0,0.7,0,1,0v43.4l-0.1-0.1L121.5,214.8z"/>
            <path class="st2" d="M390.5,214.8v148.5h-70.7v-76c0-9.7-4.4-18.6-10.6-24.8s-15-9.7-24.8-9.7H256v41.5h21.3v76
                c0,9.7,4.4,18.6,10.6,24.8c6.2,6.2,15,9.7,24.8,9.7h84.9c4.4,0,8.8-0.9,13.3-2.7c4.4-0.9,8.8-3.5,12.4-6.2
                c3.5-3.5,6.2-7.1,7.9-11.5c1.8-4.4,2.7-8.8,2.7-13.3V212.1c0-5.3-0.9-9.7-2.7-14.1c-2.6-4.4-5.3-8-8.8-11.5L280.9,61
                c-6.2-5.3-15-8.8-23.9-8.8c-0.3,0-0.7,0-1,0v43.4l0.1-0.1L390.5,214.8z"/>
        </g>
    </svg>`;

const ownerMarkerIconSvg = () => `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="30" height="30">
        <style type="text/css">
            .st0{fill:#E95969;}
            .st1{fill:#8A2BE2;}
            .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        </style>
        <g>
            <path class="st0" d="M256,506c-66.8,0-129.6-26-176.8-73.2C32,385.6,6,322.8,6,256S32,126.4,79.2,79.2C126.4,32,189.2,6,256,6
                s129.6,26,176.8,73.2C480,126.4,506,189.2,506,256s-26,129.6-73.2,176.8S322.8,506,256,506z"/>
            <path class="st1" d="M256,12c32.9,0,64.9,6.4,95,19.2c29.1,12.3,55.1,29.9,77.6,52.3c22.4,22.4,40,48.5,52.3,77.6
                c12.7,30.1,19.2,62,19.2,95s-6.4,64.9-19.2,95c-12.3,29.1-29.9,55.1-52.3,77.6c-22.4,22.4-48.5,40-77.6,52.3
                c-30.1,12.7-62,19.2-95,19.2s-64.9-6.4-95-19.2c-29.1-12.3-55.1-29.9-77.6-52.3c-22.4-22.4-40-48.5-52.3-77.6
                c-12.7-30.1-19.2-62-19.2-95s6.4-64.9,19.2-95c12.3-29.1,29.9-55.1,52.3-77.6c22.4-22.4,48.5-40,77.6-52.3
                C191.1,18.4,223.1,12,256,12 M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0L256,0z"/>
        </g>
        <g>
            <path class="st2" d="M121.5,214.8v148.5h70.7v-76c0-9.7,4.4-18.6,10.6-24.8s15-9.7,24.8-9.7H256v41.5h-21.3v76
                c0,9.7-4.4,18.6-10.6,24.8c-6.2,6.2-15,9.7-24.8,9.7h-84.9c-4.4,0-8.8-0.9-13.3-2.7c-4.4-0.9-8.8-3.5-12.4-6.2
                c-3.5-3.5-6.2-7.1-7.9-11.5c-1.8-4.4-2.7-8.8-2.7-13.3V212.1c0-5.3,0.9-9.7,2.7-14.1c2.6-4.4,5.3-8,8.8-11.5L231.1,61
                c6.2-5.3,15-8.8,23.9-8.8c0.3,0,0.7,0,1,0v43.4l-0.1-0.1L121.5,214.8z"/>
            <path class="st2" d="M390.5,214.8v148.5h-70.7v-76c0-9.7-4.4-18.6-10.6-24.8s-15-9.7-24.8-9.7H256v41.5h21.3v76
                c0,9.7,4.4,18.6,10.6,24.8c6.2,6.2,15,9.7,24.8,9.7h84.9c4.4,0,8.8-0.9,13.3-2.7c4.4-0.9,8.8-3.5,12.4-6.2
                c3.5-3.5,6.2-7.1,7.9-11.5c1.8-4.4,2.7-8.8,2.7-13.3V212.1c0-5.3-0.9-9.7-2.7-14.1c-2.6-4.4-5.3-8-8.8-11.5L280.9,61
                c-6.2-5.3-15-8.8-23.9-8.8c-0.3,0-0.7,0-1,0v43.4l0.1-0.1L390.5,214.8z"/>
        </g>
    </svg>`;

const hmoMarkerIconSvg = () => `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="30" height="30">
        <style type="text/css">
            .st0{fill:#000000;}
            .st1{fill:#8A2BE2;}
            .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        </style>
        <g>
            <path class="st0" d="M256,506c-66.8,0-129.6-26-176.8-73.2C32,385.6,6,322.8,6,256S32,126.4,79.2,79.2C126.4,32,189.2,6,256,6
                s129.6,26,176.8,73.2C480,126.4,506,189.2,506,256s-26,129.6-73.2,176.8S322.8,506,256,506z"/>
            <path class="st1" d="M256,12c32.9,0,64.9,6.4,95,19.2c29.1,12.3,55.1,29.9,77.6,52.3c22.4,22.4,40,48.5,52.3,77.6
                c12.7,30.1,19.2,62,19.2,95s-6.4,64.9-19.2,95c-12.3,29.1-29.9,55.1-52.3,77.6c-22.4,22.4-48.5,40-77.6,52.3
                c-30.1,12.7-62,19.2-95,19.2s-64.9-6.4-95-19.2c-29.1-12.3-55.1-29.9-77.6-52.3c-22.4-22.4-40-48.5-52.3-77.6
                c-12.7-30.1-19.2-62-19.2-95s6.4-64.9,19.2-95c12.3-29.1,29.9-55.1,52.3-77.6c22.4-22.4,48.5-40,77.6-52.3
                C191.1,18.4,223.1,12,256,12 M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0L256,0z"/>
        </g>
        <g>
            <path class="st2" d="M121.5,214.8v148.5h70.7v-76c0-9.7,4.4-18.6,10.6-24.8s15-9.7,24.8-9.7H256v41.5h-21.3v76
                c0,9.7-4.4,18.6-10.6,24.8c-6.2,6.2-15,9.7-24.8,9.7h-84.9c-4.4,0-8.8-0.9-13.3-2.7c-4.4-0.9-8.8-3.5-12.4-6.2
                c-3.5-3.5-6.2-7.1-7.9-11.5c-1.8-4.4-2.7-8.8-2.7-13.3V212.1c0-5.3,0.9-9.7,2.7-14.1c2.6-4.4,5.3-8,8.8-11.5L231.1,61
                c6.2-5.3,15-8.8,23.9-8.8c0.3,0,0.7,0,1,0v43.4l-0.1-0.1L121.5,214.8z"/>
            <path class="st2" d="M390.5,214.8v148.5h-70.7v-76c0-9.7-4.4-18.6-10.6-24.8s-15-9.7-24.8-9.7H256v41.5h21.3v76
                c0,9.7,4.4,18.6,10.6,24.8c6.2,6.2,15,9.7,24.8,9.7h84.9c4.4,0,8.8-0.9,13.3-2.7c4.4-0.9,8.8-3.5,12.4-6.2
                c3.5-3.5,6.2-7.1,7.9-11.5c1.8-4.4,2.7-8.8,2.7-13.3V212.1c0-5.3-0.9-9.7-2.7-14.1c-2.6-4.4-5.3-8-8.8-11.5L280.9,61
                c-6.2-5.3-15-8.8-23.9-8.8c-0.3,0-0.7,0-1,0v43.4l0.1-0.1L390.5,214.8z"/>
        </g>
    </svg>`;

const matchedMarkerIconSvg = () => `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="30" height="30">
        <style type="text/css">
            .st0{fill:#32de84;}
            .st1{fill:#8A2BE2;}
            .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        </style>
        <g>
            <path class="st0" d="M256,506c-66.8,0-129.6-26-176.8-73.2C32,385.6,6,322.8,6,256S32,126.4,79.2,79.2C126.4,32,189.2,6,256,6
                s129.6,26,176.8,73.2C480,126.4,506,189.2,506,256s-26,129.6-73.2,176.8S322.8,506,256,506z"/>
            <path class="st1" d="M256,12c32.9,0,64.9,6.4,95,19.2c29.1,12.3,55.1,29.9,77.6,52.3c22.4,22.4,40,48.5,52.3,77.6
                c12.7,30.1,19.2,62,19.2,95s-6.4,64.9-19.2,95c-12.3,29.1-29.9,55.1-52.3,77.6c-22.4,22.4-48.5,40-77.6,52.3
                c-30.1,12.7-62,19.2-95,19.2s-64.9-6.4-95-19.2c-29.1-12.3-55.1-29.9-77.6-52.3c-22.4-22.4-40-48.5-52.3-77.6
                c-12.7-30.1-19.2-62-19.2-95s6.4-64.9,19.2-95c12.3-29.1,29.9-55.1,52.3-77.6c22.4-22.4,48.5-40,77.6-52.3
                C191.1,18.4,223.1,12,256,12 M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0L256,0z"/>
        </g>
        <g>
            <path class="st2" d="M121.5,214.8v148.5h70.7v-76c0-9.7,4.4-18.6,10.6-24.8s15-9.7,24.8-9.7H256v41.5h-21.3v76
                c0,9.7-4.4,18.6-10.6,24.8c-6.2,6.2-15,9.7-24.8,9.7h-84.9c-4.4,0-8.8-0.9-13.3-2.7c-4.4-0.9-8.8-3.5-12.4-6.2
                c-3.5-3.5-6.2-7.1-7.9-11.5c-1.8-4.4-2.7-8.8-2.7-13.3V212.1c0-5.3,0.9-9.7,2.7-14.1c2.6-4.4,5.3-8,8.8-11.5L231.1,61
                c6.2-5.3,15-8.8,23.9-8.8c0.3,0,0.7,0,1,0v43.4l-0.1-0.1L121.5,214.8z"/>
            <path class="st2" d="M390.5,214.8v148.5h-70.7v-76c0-9.7-4.4-18.6-10.6-24.8s-15-9.7-24.8-9.7H256v41.5h21.3v76
                c0,9.7,4.4,18.6,10.6,24.8c6.2,6.2,15,9.7,24.8,9.7h84.9c4.4,0,8.8-0.9,13.3-2.7c4.4-0.9,8.8-3.5,12.4-6.2
                c3.5-3.5,6.2-7.1,7.9-11.5c1.8-4.4,2.7-8.8,2.7-13.3V212.1c0-5.3-0.9-9.7-2.7-14.1c-2.6-4.4-5.3-8-8.8-11.5L280.9,61
                c-6.2-5.3-15-8.8-23.9-8.8c-0.3,0-0.7,0-1,0v43.4l0.1-0.1L390.5,214.8z"/>
        </g>
    </svg>`;

const markerIconSelectedSvg = () => `
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="30" height="30">
        <style type="text/css">
            .st0{fill:#8A2BE2;}
            .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
        </style>
        <g>
            <circle class="st0" cx="256" cy="256" r="256"/>
        </g>
        <g>
            <path class="st1" d="M121.5,214.8v148.5h70.7v-76c0-9.7,4.4-18.6,10.6-24.8s15-9.7,24.8-9.7H256v41.5h-21.3v76
                c0,9.7-4.4,18.6-10.6,24.8c-6.2,6.2-15,9.7-24.8,9.7h-84.9c-4.4,0-8.8-0.9-13.3-2.7c-4.4-0.9-8.8-3.5-12.4-6.2
                c-3.5-3.5-6.2-7.1-7.9-11.5c-1.8-4.4-2.7-8.8-2.7-13.3V212.1c0-5.3,0.9-9.7,2.7-14.1c2.6-4.4,5.3-8,8.8-11.5L231.1,61
                c6.2-5.3,15-8.8,23.9-8.8c0.3,0,0.7,0,1,0v43.4l-0.1-0.1L121.5,214.8z"/>
            <path class="st1" d="M390.5,214.8v148.5h-70.7v-76c0-9.7-4.4-18.6-10.6-24.8s-15-9.7-24.8-9.7H256v41.5h21.3v76
                c0,9.7,4.4,18.6,10.6,24.8c6.2,6.2,15,9.7,24.8,9.7h84.9c4.4,0,8.8-0.9,13.3-2.7c4.4-0.9,8.8-3.5,12.4-6.2
                c3.5-3.5,6.2-7.1,7.9-11.5c1.8-4.4,2.7-8.8,2.7-13.3V212.1c0-5.3-0.9-9.7-2.7-14.1c-2.6-4.4-5.3-8-8.8-11.5L280.9,61
                c-6.2-5.3-15-8.8-23.9-8.8c-0.3,0-0.7,0-1,0v43.4l0.1-0.1L390.5,214.8z"/>
        </g>
    </svg>`;

const clusterIconSvg = () => `
    <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" r="70" stroke="#8A2BE2" stroke-width="3" />
    </svg>`;

const matchedClusterIconSvg = () => `
    <svg fill="#32de84" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" r="70" stroke="#8A2BE2" stroke-width="3" />
    </svg>`;

const ownerClusterIconSvg = () => `
    <svg fill="#E95969" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" r="70" stroke="#8a2be2" stroke-width="3" />
    </svg>`;

const hmoClusterIconSvg = () => `
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" r="70" stroke="#8a2be2" stroke-width="3" />
    </svg>`;

const clusterIconSelectedSvg = () => `
    <svg fill="#8A2BE2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
        <circle cx="120" cy="120" r="70" stroke="#8A2BE2" stroke-width="3" />
    </svg>`;

const toBase64Image = (svg) => {
    const base64 = window.btoa(svg);
    return `data:image/svg+xml;base64,${base64}`;
};

const markerIcon = () => toBase64Image(markerIconSvg());
const matchedMarkerIcon = () => toBase64Image(matchedMarkerIconSvg());
const ownerMarkerIcon = () => toBase64Image(ownerMarkerIconSvg());
const hmoMarkerIcon = () => toBase64Image(hmoMarkerIconSvg());
const markerIconSelected = () => toBase64Image(markerIconSelectedSvg());
const clusterIcon = () => toBase64Image(clusterIconSvg());
const matchedClusterIcon = () => toBase64Image(matchedClusterIconSvg());
const ownerClusterIcon = () => toBase64Image(ownerClusterIconSvg());
const hmoClusterIcon = () => toBase64Image(hmoClusterIconSvg());
const clusterIconSelected = () => toBase64Image(clusterIconSelectedSvg());

export {
    clusterIcon,
    clusterIconSelected,
    hmoClusterIcon,
    hmoMarkerIcon,
    markerIcon,
    markerIconSelected,
    matchedClusterIcon,
    matchedMarkerIcon,
    ownerClusterIcon,
    ownerMarkerIcon,
};
